import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "orderlist.icon",
  "use": "orderlist.icon-usage",
  "viewBox": "0 0 200.8 259.9",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 200.8 259.9\" id=\"orderlist.icon\"><path d=\"M166.8,27.3h-30.3v6h30.3c15.4,0,28,12.6,28,28v164.7c0,15.4-12.6,28-28,28H34.1c-15.4,0-28-12.6-28-28V61.3 c0-15.4,12.6-28,28-28h30.3v-6H34.1c-18.7,0-34,15.3-34,34v164.7c0,18.7,15.3,34,34,34h132.7c18.7,0,34-15.3,34-34V61.3 C200.8,42.5,185.5,27.3,166.8,27.3z\" /><path d=\"M119.6 18.9c-.2-10.4-8.7-18.8-19.2-18.8s-19 8.4-19.1 18.8h-9.5v22.7h57.3V18.9H119.6zM100.5 5.1c7.7 0 14 6.2 14.2 13.8H86.3C86.5 11.3 92.8 5.1 100.5 5.1zM32.8 72.3H59.5V99H32.8zM73.5 81.9H168.2V89.2H73.5zM32.8 130.3H59.5V157H32.8zM73.5 139.9H168.2V147.20000000000002H73.5z\" /><g><path d=\"M32.8 188.3H59.5V215H32.8zM73.5 197.9H168.2V205.20000000000002H73.5z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/orderlist.icon.svg
// module id = zMt2
// module chunks = 13